<template>
    <framework>
        <template #side>
            <course-side-nav v-if="!loading"/>
        </template>
        <template #main>
            <div class="content-frame content pl-5 pt-6" v-if="loading">
                <h4 class="has-text-white"><i class="fas fa-spinner fa-spin mr-4"></i>Please wait. Loading content...</h4>
            </div>

            <template v-else>
                <b-message
                    type="is-danger"
                    v-if="enrollment.course.test_mode"
                >
                    <div class="columns">
                        <div class="column">
                            <strong>Notice:</strong> This course is currently in test mode.
                        </div>
                        <div class="column has-text-right is-narrow">
                            <b-button type="is-danger" size="is-small" @click="testReset"><i class="fas fa-rotate-left mr-2"></i>Reset Enrollment</b-button>
                        </div>
                    </div>

                </b-message>
                <main-header
                    :title="customCourseName || enrollment.course.title"
                    :subtitle="customCourseName ? enrollment.course.title : null"
                    icon="fa-chalkboard-teacher"
                />
                <router-view/>
            </template>
        </template>
    </framework>
</template>

<script>
    import Framework from "../../components/framework/Framework";
    import CourseSideNav from "../../components/course/CourseSideNav.vue";
    import MainHeader from "../../components/framework/MainHeader";

    import {mapActions, mapGetters} from "vuex";
    import {client as http} from "../../http_client";

    export default {
        components: {Framework, CourseSideNav, MainHeader},
        data: function() {
            return {
                loading: true,
                loadedEnrollmentId: null  // Track which enrollment we've loaded
            };
        },
        computed: {
            ...mapGetters(['enrollment']),
            // Always use route params as the single source of truth
            currentEnrollmentId: function() {
                return this.$route.params.enrollmentId;
            },
            customCourseName() {
                const name = this.enrollment?.custom_name;
                return (name || '').trim() || null;
            },
        },
        methods: {
            ...mapActions(['getEnrollmentById']),
            load: function() {
                const enrollmentId = this.currentEnrollmentId;

                if (!enrollmentId) {
                    console.error('[Course.vue] No enrollment ID in route params:', this.$route.params);
                    console.error('[Course.vue] Current path:', this.$route.path);
                    return;
                }

                // Always force a fresh load if the enrollment ID changed
                const needsLoad = this.loadedEnrollmentId !== enrollmentId;

                if (!needsLoad && this.enrollment && this.enrollment.id === parseInt(enrollmentId)) {
                    // Already loaded this enrollment
                    this.loading = false;
                    return;
                }

                this.loading = true;
                this.loadedEnrollmentId = enrollmentId;

                this.getEnrollmentById(enrollmentId).then(() => {
                    this.loading = false;
                }).catch(err => {
                    console.error('[Course.vue] Error loading enrollment:', err);
                    // Removed, or not this student's: nothing to show here
                    // (the store rejects with the axios response, not the error)
                    if (err && err.status === 404) {
                        this.$router.replace({name: 'dashboard'});
                    }
                });
            },
            testReset: function() {
                if (confirm('Are you sure you want to reset this enrollment? This will remove all progress.')) {
                    http.post('app/enrollments/' + this.currentEnrollmentId + '/reset').then(() => {
                        this.getEnrollmentById(this.currentEnrollmentId);
                    }).catch(err => {
                        console.log(err);
                    });
                }
            }
        },
        watch: {
            // Watch for route param changes (navigation without remount)
            '$route.params.enrollmentId': function(newId, oldId) {
                if (newId && newId !== oldId) {
                    this.loadedEnrollmentId = null;
                    this.load();
                }
            }
        },
        mounted() {
            // Wait for next tick to ensure route is fully resolved
            this.$nextTick(() => {
                this.load();
            });
        }
    };
</script>

<style lang="scss" scoped>

</style>
